import React from "react";
import { MapPin, Loader2, Globe } from "lucide-react";

// Small UI badge that lets users switch between "Near me" and "All India".
// Drop into any directory page (Vets / Hostels / Store / NGOs).
export default function GeoToggle({ geo, label = "results" }) {
  const { mode, setMode, isNearby, requesting, request, error, radius } = geo;

  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="geo-toggle">
      <div className="inline-flex rounded-full border border-line bg-surface p-1 shadow-soft">
        <button
          type="button"
          data-testid="geo-mode-nearby"
          onClick={() => {
            if (!isNearby) request();
            else setMode("nearby");
          }}
          className={`px-3 py-1.5 rounded-full text-xs font-bold inline-flex items-center gap-1.5 transition-colors ${
            mode === "nearby" ? "bg-brand text-white" : "text-ink-soft hover:text-ink"
          }`}
        >
          {requesting ? <Loader2 className="w-3 h-3 animate-spin"/> : <MapPin className="w-3 h-3"/>}
          Near me {isNearby && <span className="opacity-80">· {radius}km</span>}
        </button>
        <button
          type="button"
          data-testid="geo-mode-all"
          onClick={() => setMode("all")}
          className={`px-3 py-1.5 rounded-full text-xs font-bold inline-flex items-center gap-1.5 transition-colors ${
            mode === "all" ? "bg-ink text-white" : "text-ink-soft hover:text-ink"
          }`}
        >
          <Globe className="w-3 h-3"/> All India
        </button>
      </div>
      {error && mode === "nearby" && !isNearby && (
        <span className="text-[11px] text-ink-soft">
          Location off — showing all {label}. <button onClick={request} className="underline font-bold">Retry</button>
        </span>
      )}
    </div>
  );
}
